(function(_){
    'use strict';
    _['FREE.KEY']='Página';
    _['FREE.NO-CONTENT'] = 'Não há conteúdo neste módulo';
}(translations['pt']));












// WEBPACK FOOTER //
// ./src/app/modules/free/lang/free-lang_pt.js